var _circle, _circle2, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitHubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_917_14)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 12,
    fill: "url(#paint1_linear_917_14)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1C7.265 1 1 7.19406 1 14.8415C1 20.9663 5.0075 26.1396 10.5725 27.9736C11.2725 28.0947 11.535 27.6794 11.535 27.3161C11.535 26.9874 11.5175 25.8973 11.5175 24.7381C8 25.3783 7.09 23.8903 6.81 23.1117C6.6525 22.7138 5.97 21.4854 5.375 21.1566C4.885 20.8971 4.185 20.2569 5.3575 20.2396C6.46 20.2223 7.2475 21.2431 7.51 21.6584C8.77 23.7519 10.7825 23.1636 11.5875 22.8003C11.71 21.9006 12.0775 21.295 12.48 20.949C9.365 20.603 6.11 19.4091 6.11 14.1148C6.11 12.6095 6.6525 11.3638 7.545 10.3949C7.405 10.0489 6.915 8.63011 7.685 6.72691C7.685 6.72691 8.8575 6.36357 11.535 8.14566C12.655 7.83422 13.845 7.67851 15.035 7.67851C16.225 7.67851 17.415 7.83422 18.535 8.14566C21.2125 6.34627 22.385 6.72691 22.385 6.72691C23.155 8.63011 22.665 10.0489 22.525 10.3949C23.4175 11.3638 23.96 12.5922 23.96 14.1148C23.96 19.4265 20.6875 20.603 17.5725 20.949C18.08 21.3816 18.5175 22.212 18.5175 23.5097C18.5175 25.361 18.5 26.8489 18.5 27.3161C18.5 27.6794 18.7625 28.112 19.4625 27.9736C22.2417 27.0459 24.6567 25.2799 26.3676 22.9242C28.0785 20.5684 28.9992 17.7416 29 14.8415C29 7.19406 22.735 1 15 1Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1C7.265 1 1 7.19406 1 14.8415C1 20.9663 5.0075 26.1396 10.5725 27.9736C11.2725 28.0947 11.535 27.6794 11.535 27.3161C11.535 26.9874 11.5175 25.8973 11.5175 24.7381C8 25.3783 7.09 23.8903 6.81 23.1117C6.6525 22.7138 5.97 21.4854 5.375 21.1566C4.885 20.8971 4.185 20.2569 5.3575 20.2396C6.46 20.2223 7.2475 21.2431 7.51 21.6584C8.77 23.7519 10.7825 23.1636 11.5875 22.8003C11.71 21.9006 12.0775 21.295 12.48 20.949C9.365 20.603 6.11 19.4091 6.11 14.1148C6.11 12.6095 6.6525 11.3638 7.545 10.3949C7.405 10.0489 6.915 8.63011 7.685 6.72691C7.685 6.72691 8.8575 6.36357 11.535 8.14566C12.655 7.83422 13.845 7.67851 15.035 7.67851C16.225 7.67851 17.415 7.83422 18.535 8.14566C21.2125 6.34627 22.385 6.72691 22.385 6.72691C23.155 8.63011 22.665 10.0489 22.525 10.3949C23.4175 11.3638 23.96 12.5922 23.96 14.1148C23.96 19.4265 20.6875 20.603 17.5725 20.949C18.08 21.3816 18.5175 22.212 18.5175 23.5097C18.5175 25.361 18.5 26.8489 18.5 27.3161C18.5 27.6794 18.7625 28.112 19.4625 27.9736C22.2417 27.0459 24.6567 25.2799 26.3676 22.9242C28.0785 20.5684 28.9992 17.7416 29 14.8415C29 7.19406 22.735 1 15 1Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14C19 15.3333 18.5521 16 17.9997 16C17.4472 16 17 15.3333 17 14C17 12.6667 17.4472 12 17.9997 12C18.5521 12 19 12.6667 19 14Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 15.3333 12.5521 16 11.9997 16C11.4472 16 11 15.3333 11 14C11 12.6667 11.4472 12 11.9997 12C12.5521 12 13 12.6667 13 14Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_14",
    x1: 14.5,
    y1: -21.5,
    x2: 15,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AA771C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#FBF5B7",
    stopOpacity: 0.286458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#B38728",
    stopOpacity: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#FCF6BA",
    stopOpacity: 0.713542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_14",
    x1: 15,
    y1: -10.6,
    x2: 15,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF953F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCF6BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B38728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBF5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubIcon);
export default __webpack_public_path__ + "static/media/gitHubIcon.5f3ec158f7da89ac6173dc9b809753e1.svg";
export { ForwardRef as ReactComponent };